import baseClasses from '@components/Themes/layout.module.scss'
import axios from 'axios'
import React, { FunctionComponent } from 'react'

import '@components/MapBox/mapbox.css'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import parqueDiamantemodulescss from 'dist/css/parqueDiamante.module.scss'
import type { LayerProps } from 'react-map-gl'
import Map, { Layer, ScaleControl, Source } from 'react-map-gl'
import QRCode from 'react-qr-code'
import { NavLink } from 'react-router-dom'

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'circle',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': ['step', ['get', 'point_count'], 'rgba(206, 13, 45, 0.75)', 10, 'rgba(206, 13, 45, 0.5)', 750, '#f28cb1'],
    'circle-radius': ['step', ['get', 'point_count'], 16, 10, 32, 750, 64],
  },
}

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'earthquakes',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 10,
  },
}

export const unclusteredPointLayer: LayerProps = {
  id: 'unclustered-point',
  type: 'circle',
  source: 'earthquakes',
  filter: ['!', ['has', 'point_count']],
  paint: {
    'circle-color': 'rgb(206, 13, 45)',
    'circle-opacity': 0.84,
    'circle-radius': 8,
    'circle-stroke-width': 2,
    'circle-stroke-color': '#fff',
  },
}

const MapaMistico: FunctionComponent = (props: any) => {
  const {
    history: navigation,
    match: { params },
  } = props
  const classes = baseClasses
  const theme = { ...baseClasses, ...parqueDiamantemodulescss }
  const [downloadPopUp, setdownloadPopUp] = React.useState<any>(false)
  const [dotImages, setdotImages] = React.useState<any>([])
  const [locat, setlocat] = React.useState<any>({
    accuracy: 5,
    altitude: 0,
    altitudeAccuracy: -1,
    heading: -1,
    latitude: -34.5649,
    longitude: -58.4543,
    speed: -1,
  })
  const [dotDetails, setdotDetails] = React.useState<any>({})
  const [originalLocat, setoriginalLocat] = React.useState<any>({ latitude: -30, longitude: -70 })
  const [routeName, setrouteName] = React.useState<any>(null)
  const [theData, settheData] = React.useState<any>({ type: 'FeatureCollection', features: [] })
  const [zoom, setzoom] = React.useState<any>(10)
  const [markers, setmarkers] = React.useState<any>([])
  const [region, setregion] = React.useState<any>(null)
  const [selectedDot, setselectedDot] = React.useState<any>(null)
  const [loading, setloading] = React.useState<any>(true)
  const [coordinatesMap, setcoordinatesMap] = React.useState<any>(null)
  const [mapURL, setmapURL] = React.useState<any>(null)
  const [dotImagesRoute, setdotImagesRoute] = React.useState<any>()
  const [languaje, setlanguaje] = React.useState<any>('es')

  const langStrings = {
    es: {
      map: 'Mapa',
      destinations: 'Destinos',
      routes: 'Rutas',
      shops: 'Comercios',
      loading: 'Cargando',
      showing: `Mostrando ${theData.features.length} puntos cercanos`,
      showMore: 'Ver Mas',
      preDistance: 'A ',
      postDistance: ' km de distancia',
    },
    en: {
      map: 'Map',
      destinations: 'Destinations',
      routes: 'Routes',
      shops: 'Shops',
      loading: 'Loading',
      showing: `Showing ${theData.features.length} nearby locations`,
      showMore: 'Show More',
      preDistance: '',
      postDistance: ' km away',
    },
  }

  const mapRef = React.useRef<any>()

  const backTo = 'back'

  const mainPage = null

  let pageTitle
  if (params.id === '1720549670281') {
    pageTitle = 'Aventura en Diamante'
  } else if (params.id === '1720471145162') {
    pageTitle = 'Santuario de Animales'
  } else if (params.id === 'Descarga') {
    pageTitle = '¡Descarga Real Travel!'
  } else {
    pageTitle = routeName !== null ? routeName : '¡Descarga Real Travel!'
  }

  const getMatch = (coordinates, radius, profile = 'cycling') => {
    const radiuses = radius.join(';')

    const url = `/api/routePath?profile=${profile}&coordinates=${coordinates}&radiuses=${radiuses}`

    axios
      .get(`https://admin.realtravelapp.com/backend${url}`)
      .then((result) => {
        setmarkers(result.data.coordinates)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const calculateRadius = (swLatitude, swLongitude, neLatitude, neLongitude) => {
    const earthRadius = 6371

    const latDiff = Math.abs(neLatitude - swLatitude)

    const lngDiff = Math.abs(neLongitude - swLongitude)

    const diagonalDistance = Math.sqrt(Math.pow(latDiff, 2) + Math.pow(lngDiff, 2))

    const radius = diagonalDistance / 2

    return radius * earthRadius
  }

  const onMapIdle = (newRegion) => {
    if (!mapRef.current || mapRef.current.getCenter().lng === 0) {
      return
    }

    if (!mapRef.current.getBounds) {
      if (newRegion && newRegion.gestures.isGestureActive) {
        setlocat({ longitude: Number(newRegion.properties.center[0]), latitude: Number(newRegion.properties.center[1]) })
      }

      const regionActual = region ? JSON.stringify(region.properties.bounds) : null
      const newRegionJSON = JSON.stringify(newRegion.properties.bounds)
      if (newRegionJSON && newRegionJSON !== regionActual) {
        setregion(newRegion)
      }
    }

    if (mapRef.current.getBounds) {
      const bounds = mapRef.current.getBounds()
      const mapprops = {
        properties: {
          center: [mapRef.current.getCenter().lng, mapRef.current.getCenter().lat],
          bounds: {
            sw: [bounds._sw.lat, bounds._sw.lng],
            ne: [bounds._ne.lat, bounds._ne.lng],
          },
        },
      }
      if (
        mapprops &&
        mapprops.properties?.center[0] !== region?.properties?.center[0] &&
        mapprops.properties?.center[1] !== region?.properties?.center[1]
      ) {
        setregion(mapprops)

        setlocat({ longitude: Number(mapprops.properties.center[0]), latitude: Number(mapprops.properties.center[1]) })

        mapRef.current?.flyTo({ center: mapprops.properties.center, duration: 2000 })
      }
    }
  }

  const bringRouteDetails = (dotID) => {
    axios
      .get(`https://admin.realtravelapp.com/backend/api/routeDetails?id=${params.id}`)
      .then((result) => {
        const coordinates: any = []
        const radiouses: any = []
        const newData = result.data.docs[0].routePoints
          .sort((a, b) => (a.position > b.position ? 1 : -1))
          .map((feature) => {
            coordinates.push([Number(feature.long), Number(feature.lat)])
            radiouses.push(25)
            return {
              type: 'Feature',
              properties: { ...feature, image: feature.type.icon },
              geometry: { type: 'Point', coordinates: [Number(feature.long), Number(feature.lat), 1.77] },
            }
          })

        if (result.data.docs[0].mapURL) {
          const maxBoundsString = result.data.docs[0]?.maxBounds
          const jsonString = `{${maxBoundsString.replace(/(\w+):/g, '"$1":')}}`
          const maxBounds = JSON.parse(jsonString)
          //setmaxBoundsMap(maxBounds)

          const coordenadasIniciales = JSON.parse(result.data.docs[0].coordinates)
          setcoordinatesMap(coordenadasIniciales)

          setmapURL(result.data.docs[0].mapURL)
        }
        settheData({ type: 'FeatureCollection', features: newData })
        getMatch(coordinates.join(';'), radiouses)
        setrouteName(result.data.docs[0].name)
        setloading(false)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  React.useEffect(() => {
    if (theData?.features) {
      const latitud = parseFloat(theData?.features[0]?.geometry?.coordinates[1])
      const longitud = parseFloat(theData?.features[0]?.geometry?.coordinates[0])
      if (!isNaN(latitud) && !isNaN(longitud)) {
        // Actualizar locat con las coordenadas
        setlocat({ ...locat, latitude: latitud, longitude: longitud })
      }
    }
  }, [theData])

  const closePopUp = () => {
    setdownloadPopUp(false)

    mapRef.current?.flyTo({ center: [-72.9809486435779, -41.31641271928485], duration: 2000, zoom: 15 })
  }

  React.useEffect(() => {
    ;(async () => {
      bringRouteDetails(params.id)
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setlocat({ longitude: Number(position.coords.longitude), latitude: Number(position.coords.latitude) })

          if (position.coords.latitude) {
            setoriginalLocat({ longitude: Number(position.coords.longitude), latitude: Number(position.coords.latitude) })
            if (params?.ID === 'CasinoDreamsPuertoVaras') {
              mapRef.current?.flyTo({ center: [-72.9809486435779, -41.31641271928485], duration: 2000 })
            }
          } else {
            setoriginalLocat(position.coords)
          }
        },
        (error) => {
          console.error('Geolocation Error:', error)
        }
      )
    })()
  }, [params.id])

  React.useEffect(() => {
    ;(async () => {
      bringRouteDetails(params.id)
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setlocat({ longitude: Number(position.coords.longitude), latitude: Number(position.coords.latitude) })

          if (position.coords.latitude) {
            setoriginalLocat({ longitude: Number(position.coords.longitude), latitude: Number(position.coords.latitude) })
            if (params?.ID === 'CasinoDreamsPuertoVaras') {
              mapRef.current?.flyTo({ center: [-72.9809486435779, -41.31641271928485], duration: 2000 })
            }
          } else {
            setoriginalLocat(position.coords)
          }
        },
        (error) => {
          console.error('Geolocation Error:', error)
        }
      )
    })()
  }, [])

  // Theme selection

  return (
    <React.Fragment>
      <div className={classes.mainPanel}>
        <Dialog
          open={downloadPopUp}
          onClose={(e) => {
            setdownloadPopUp(false)
          }}
          maxWidth={'md'}
          className={theme.downPopUp}
        >
          <DialogTitle>
            <div data-title="closeIcon" className={theme.closeIcon} style={{ cursor: 'pointer' }} onClick={(e) => closePopUp()}>
              <picture>
                <img src="/img/closeIcon.png" alt="/img/closeIcon.png" width="30" height="30" />
              </picture>
            </div>
          </DialogTitle>

          <DialogContent>
            <div data-title="title Container" className={theme.titleContainer}>
              <Typography variant="h5">Para seguir navegando por Real Travel</Typography>

              <Typography variant="h4">¡Descarga la app en tu celular!</Typography>
            </div>

            <div data-title="container" className={theme.container}>
              <div data-title="IOS" className={theme.eachSide}>
                <div data-title="div" className={theme.title}>
                  Descargar para IOS
                </div>

                <div data-title="div" className={theme.QR}>
                  <QRCode
                    width={300}
                    height={300}
                    style={{ height: '300px', maxWidth: '100%', width: '100%' }}
                    level="H"
                    value={'https://downloadios.aptugo.app'}
                    bgColor="black"
                    fgColor="white"
                  />
                </div>
              </div>

              <div data-title="Android" className={theme.eachSide}>
                <div data-title="div" className={theme.title}>
                  Descargar para Android
                </div>

                <div data-title="div" className={theme.QR}>
                  <QRCode
                    width={300}
                    height={300}
                    style={{ height: '300px', maxWidth: '100%', width: '100%' }}
                    level="H"
                    value={'https://downloadandroid.aptugo.app'}
                    bgColor="white"
                    fgColor="black"
                  />
                </div>
              </div>
            </div>
          </DialogContent>

          <DialogActions></DialogActions>
        </Dialog>

        <Dialog
          open={!!selectedDot}
          onClose={(e) => {
            setselectedDot(null)
          }}
          className={theme.popUpDots}
        >
          <div data-title="Modal View" className={theme.modalView}>
            <div data-title="popupOneLiner" className={theme.popupOneLiner}>
              <picture className={theme.popupImage}>
                <img src={`${selectedDot?.features[0].properties.cover_url}`} alt={`${selectedDot?.features[0].properties.cover_url}`} />
              </picture>
              <div data-title="div" className={theme.nameAndDistance}>
                <span className={theme.popupName}>
                  {languaje === 'en' ? selectedDot?.features[0].properties.en_name : selectedDot?.features[0].properties.name}
                </span>
              </div>
            </div>

            <span className={theme.popupDescription}>
              {languaje === 'en' ? selectedDot?.features[0].properties.en_description : selectedDot?.features[0].properties.description} ...
            </span>

            <Button
              onClickCapture={(e) => {
                setdownloadPopUp(true)
              }}
              className={theme.showMoreButton}
              fullWidth
            >
              {langStrings[languaje].showMore}
            </Button>
          </div>
        </Dialog>

        <div data-title="Bottom Menu" className={theme.bottomMenu}>
          <div data-title="Ruta Parque completo" className={theme.bottomLink}>
            <NavLink className={theme.bottomLink} to="/Mistico/1736514812596">
              <span className={theme.bottomLinkText}>Místico Park</span>
            </NavLink>
          </div>

          <div data-title="Descarga RT" className={theme.bottomLink}>
            <NavLink className={theme.bottomLink} to="/Mistico/Descarga">
              <span className={theme.bottomLinkText}>Descarga Real Travel</span>
            </NavLink>
          </div>
        </div>

        {params.id == 'Descarga' && (
          <React.Fragment>
            <div data-title="div" className={theme.descargaRT}>
              <picture className={theme.imgDiamante}>
                <img src="/img/RT_roj_frase.png" alt="/img/RT_roj_frase.png" width="300" height="79" />
              </picture>
              <div data-title="container" className={theme.container}>
                <div data-title="div" className={theme.redirect}>
                  <a
                    target="_blank"
                    className={theme.linkT}
                    href="https://linktr.ee/realtravelap?fbclid=PAZXh0bgNhZW0CMTEAAaaoP7ADvVgADbOm7Nod0HrVqIYUHpKEcSl940o5UxU6voc1DavpNM5W--k_aem_DsjjGZqJPndrQ-OCgDpyhQ"
                  >
                    <span className={theme.textLinkT}>¡Descarga la App!</span>
                  </a>
                </div>
              </div>

              <div data-title="title Container" className={theme.titleContainer}>
                <Typography variant="h4">¡Disfruta Místico y descubre todo lo que tiene para ofrecer Costa Rica!</Typography>
              </div>
            </div>
          </React.Fragment>
        )}

        {params.id == 1736514812596 && (
          <React.Fragment>
            <div className={theme.mapBox}>
              <Map
                interactiveLayerIds={['IHEz6keJ', 'q2g5liWK', 'uvAumdOd', 'bNpZuAnp']}
                initialViewState={{
                  latitude: locat.latitude,
                  longitude: locat.longitude,
                  zoom: zoom,
                  bearing: 0,
                  pitch: 0,
                }}
                ref={mapRef}
                mapStyle="mapbox://styles/mapbox/light-v9"
                mapboxAccessToken="pk.eyJ1IjoiZ2FzdG9uaXVzIiwiYSI6ImNsZXNlenR1bDAweHMzdGx3MjhnNWdhaGUifQ.mAVnr_Q8timexh8L4tGEQA"
                onLoad={(e) => {
                  if (mapRef.current) {
                    const loadURL = (url) => {
                      return axios.get(url, { responseType: 'arraybuffer' }).then((response) => {
                        const imageBlob = new Blob([response.data], { type: 'image/jpeg' })
                        return URL.createObjectURL(imageBlob)
                      })
                    }

                    mapRef.current.on('styleimagemissing', (e) => {
                      loadURL(e.id).then((response) => {
                        mapRef.current.loadImage(response, (error, image) => {
                          if (error) return
                          mapRef.current.addImage(e.id, image)
                        })
                      })
                    })
                  }
                }}
                maxBounds={[
                  [-84.75723611111111, 10.485894444444445],
                  [-84.74992222222222, 10.498672222222222],
                ]}
                onIdle={onMapIdle}
                onClick={async (pressedShape) => {
                  if (pressedShape.features[0]) {
                    const feature = pressedShape.features[0]
                    const clusterId = feature.properties.cluster_id
                    if (clusterId) {
                      mapRef.current.getSource('LZXmMSeZ').getClusterExpansionZoom(clusterId, (err, zoom) => {
                        if (err) return
                        mapRef.current?.flyTo({ center: feature.geometry.coordinates, duration: 500, zoom: mapRef.current.getZoom() + 1 })
                      })
                    } else {
                      setselectedDot({ ...pressedShape })
                    }
                  }
                }}
              >
                <ScaleControl />

                {/* Capa de imagen */}
                <Source
                  id="image-source"
                  type="image"
                  url="https://rtadmin-789e3.appspot.com.storage.googleapis.com/types/MP_MISTICO2025-min_2.jpeg"
                  coordinates={[
                    [-84.75723611111111, 10.498672222222222],
                    [-84.74992222222222, 10.498672222222222],
                    [-84.74992222222222, 10.485894444444445],
                    [-84.75723611111111, 10.485894444444445],
                  ]}
                >
                  <Layer
                    id="image-layer"
                    type="raster"
                    source="image-source"
                    paint={{
                      'raster-opacity': 0.85,
                    }}
                  />
                </Source>

                <Source
                  id="IHEz6keJ"
                  type="geojson"
                  data={theData as unknown as any}
                  cluster={true}
                  clusterMaxZoom={14}
                  clusterRadius={50}
                  clusterProperties={{
                    mag1: [
                      ['+', ['accumulated'], ['get', 'mag1']],
                      ['case', ['<', ['get', 'mag'], 2], 1, 0],
                    ],
                    mag2: [
                      ['+', ['accumulated'], ['get', 'mag2']],
                      ['case', ['all', ['>=', ['get', 'mag'], 2], ['<', ['get', 'mag'], 3]], 1, 0],
                    ],
                    mag3: [
                      ['+', ['accumulated'], ['get', 'mag3']],
                      ['case', ['all', ['>=', ['get', 'mag'], 3], ['<', ['get', 'mag'], 4]], 1, 0],
                    ],
                    mag4: [
                      ['+', ['accumulated'], ['get', 'mag4']],
                      ['case', ['all', ['>=', ['get', 'mag'], 4], ['<', ['get', 'mag'], 5]], 1, 0],
                    ],
                    mag5: [
                      ['+', ['accumulated'], ['get', 'mag5']],
                      ['case', ['>=', ['get', 'mag'], 5], 1, 0],
                    ],
                  }}
                >
                  <Layer id="q2g5liWK" type="symbol" layout={{}} paint={{}} />

                  <Layer
                    type="circle"
                    id="uvAumdOd"
                    filter={['has', 'point_count']}
                    style={{
                      circlePitchAlignment: 'map',
                      circleColor: ['step', ['get', 'point_count'], 'rgba(206, 13, 45, 0.75)', 10, 'rgba(206, 13, 45, 0.5)', 750, '#f28cb1'],
                      circleRadius: ['step', ['get', 'point_count'], 16, 10, 32, 750, 64],
                      circleOpacity: 0.84,
                      circleStrokeWidth: 2,
                      circleStrokeColor: 'white',
                    }}
                    paint={{}}
                  />

                  <Layer
                    id="bNpZuAnp"
                    type="symbol"
                    filter={['!', ['has', 'point_count']]}
                    layout={{
                      'icon-image': ['get', 'image'],
                      'icon-size': [
                        'interpolate',
                        ['exponential', 1.5],
                        ['zoom'],
                        0.5,
                        0.1,
                        2.5,
                        0.1,
                        4.5,
                        0.15,
                        8,
                        0.15,
                        12,
                        0.15,
                        15.2,
                        0.15,
                        16,
                        0.2,
                        17,
                        0.25,
                        17.5,
                        0.3,
                        18,
                        0.35,
                        20,
                        0.4,
                        21,
                        0.45,
                        22,
                        0.45,
                        23,
                        0.45,
                        24,
                        0.45,
                      ],
                      'icon-allow-overlap': true,
                    }}
                    paint={{}}
                  />
                </Source>
              </Map>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}

export default MapaMistico
